<template>
  <div>
    <el-card style="margin-top: 20px" shadow="never">
      <el-button
        type="primary"
        @click="addLinks"
        size="mini"
        :disabled="tableData.length == 2"
        >添加链接</el-button
      >
      <div class="classTable1">
        <el-table
          style="margin-top: 20px;"
          :data="tableData"
          row-key="index"
          :header-cell-style="{ background: '#f5f7fa' }"
        >
          <el-table-column prop="name" label="名称"></el-table-column>
          <el-table-column prop="link" label="链接"></el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button
                size="small"
                type="text"
                @click="updateLinks(scope.row, scope.$index)"
                >修改</el-button
              >
              <el-button
                size="small"
                type="text"
                @click="deleteLinks(scope.row)"
                >删除</el-button
              >
              <el-button size="small" type="text">
                <i class="el-icon-rank"></i>
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-card>

    <el-dialog title="外部链接" :visible.sync="dialogVisible" width="600px">
      <el-form
        class="form-style"
        ref="form1"
        :model="form1"
        :rules="rules"
        label-width="100px"
        label-position="right"
      >
        <el-form-item label="名称" required>
          <el-input
            placeholder="请输入名称"
            v-model="form1.name"
            style="width: 400px"
            maxlength="6"
            show-word-limit
          >
          </el-input>
        </el-form-item>

        <el-form-item label="链接" required>
          <el-input
            placeholder="请输入跳转链接"
            v-model="form1.link"
            style="width: 400px"
            maxlength="500"
            show-word-limit
          >
          </el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" type="primary" @click="submit1('form1')"
          >保存</el-button
        >
        <el-button size="small" @click="dialogVisible = false">关 闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { updateHomepage } from '@/api/homeset'
import Sortable from 'sortablejs'
export default {
  name: 'homeset-logoset',
  props: {
    homepage_id: Number,
    self_header_button: Array,
  },
  data() {
    return {
      tableIndex: 0,
      editIs: true,
      form1: {
        name: '',
        link: '',
      },
      dialogVisible: false,
      tableData: [],
      rules: {
        name: [{ required: true, message: '请输入标题', trigger: 'blur' }],
        link: [{ required: true, message: '请输入链接', trigger: 'blur' }],
      },
    }
  },
  watch: {
    self_header_button(val) {
      console.log(val, 789465456)
      this.tableData = val
      console.log(this.tableData, 789465456)
    },
  },
  created() {},
  mounted() {
    this.rowDrop1()
  },
  methods: {
    rowDrop1() {
      // 要侦听拖拽响应的DOM对象
      const tbody = document.querySelector(
        '.classTable1 .el-table__body-wrapper tbody'
      )
      const that = this
      console.log(that.tableData, 4547878)
      Sortable.create(tbody, {
        animation: 1000,
        ghostClass: 'ghostClass', //设置拖拽停靠样式类名
        chosenClass: 'chosenClass', //设置选中样式类名
        handle: '.el-icon-rank',
        // 结束拖拽后的回调函数
        onEnd({ newIndex, oldIndex }) {
          console.log('拖动了行，当前序号：' + newIndex)
          const currentRow = that.tableData.splice(oldIndex, 1)[0]
          that.tableData.splice(newIndex, 0, currentRow)
          console.log(that.tableData, 123456)
          updateHomepage({
            id: that.homepage_id,
            self_header_button: JSON.stringify(that.tableData),
          }).then((res) => {
            if (res.is_update) {
              // that.dialogVisible = false
              console.log(res.result.self_header_button, 123456)
              that.tableData = []
              that.$nextTick(() => {
                that.tableData.push(...res.result.self_header_button)
                console.log(that.tableData, 123456)
                let schoolInfo1 = JSON.parse(
                  sessionStorage.getItem('schoolInfo')
                )
                schoolInfo1.homepageData.homepage.self_header_button =
                  that.tableData
                sessionStorage.setItem(
                  'schoolInfo',
                  JSON.stringify(schoolInfo1)
                )
                console.log(
                  JSON.parse(sessionStorage.getItem('schoolInfo')),
                  789456143
                )
              })

              that.$message.success('保存成功！')
            }
          })
        },
      })
    },
    deleteLinks(row) {
      this.tableData.splice(this.tableData.indexOf(row), 1)
      console.log(this.tableData, 21235)
      updateHomepage({
        id: this.homepage_id,
        self_header_button: JSON.stringify(this.tableData),
      }).then((res) => {
        if (res.is_update) {
          this.$message.success('保存成功！')
          let schoolInfo1 = JSON.parse(sessionStorage.getItem('schoolInfo'))
          schoolInfo1.homepageData.homepage.self_header_button =
            res.result.self_header_button
          sessionStorage.setItem('schoolInfo', JSON.stringify(schoolInfo1))
          console.log(
            JSON.parse(sessionStorage.getItem('schoolInfo')),
            789456143
          )
        }
      })
    },
    updateLinks(row, index) {
      this.editIs = false
      console.log(index, 123456)
      this.form1.name = row.name
      this.form1.link = row.link
      this.tableIndex = index
      this.dialogVisible = true
    },
    addLinks() {
      this.editIs = true
      this.form1.name = ''
      this.form1.link = ''
      // this.form1.imageId = "";
      this.dialogVisible = true
    },
    submit1(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.editIs == true) {
            this.tableData.push(this.form1)
            console.log(this.tableData, 125458)
            updateHomepage({
              id: this.homepage_id,
              self_header_button: JSON.stringify(this.tableData),
            }).then((res) => {
              if (res.is_update) {
                this.$message.success('保存成功！')
                this.dialogVisible = false
                console.log(res.result.self_header_button, 1245645)
                this.tableData = res.result.self_header_button
                let schoolInfo1 = JSON.parse(
                  sessionStorage.getItem('schoolInfo')
                )
                schoolInfo1.homepageData.homepage.self_header_button =
                  res.result.self_header_button
                sessionStorage.setItem(
                  'schoolInfo',
                  JSON.stringify(schoolInfo1)
                )
                console.log(
                  JSON.parse(sessionStorage.getItem('schoolInfo')),
                  789456143
                )
              }
            })
          } else {
            this.tableData[this.tableIndex].name = this.form1.name
            this.tableData[this.tableIndex].link = this.form1.link
            console.log(this.tableData, 123456)
            updateHomepage({
              id: this.homepage_id,
              self_header_button: JSON.stringify(this.tableData),
            }).then((res) => {
              if (res.is_update) {
                this.$message.success('保存成功！')
                this.dialogVisible = false
                let schoolInfo1 = JSON.parse(
                  sessionStorage.getItem('schoolInfo')
                )
                schoolInfo1.homepageData.homepage.self_header_button =
                  res.result.self_header_button
                sessionStorage.setItem(
                  'schoolInfo',
                  JSON.stringify(schoolInfo1)
                )
                console.log(
                  JSON.parse(sessionStorage.getItem('schoolInfo')),
                  789456143
                )
              }
            })
          }
        }
      })
    },
  },
}
</script>

<style scoped lang="scss">
.table-style {
  margin-top: 20px;
}
</style>
